<script>
  import { extent } from "d3-array";
  import { csv, json } from "d3-request";
  import { scaleDiverging, scaleSequential, scaleLinear } from "d3-scale";
  import { mouse } from "d3-selection";
  import { interpolateRdBu } from "d3-scale-chromatic";
  import {
    geoEqualEarth,
    geoOrthographic,
    geoPath,
    geoCentroid,
    geoGraticule10,
    geoAlbersUsa,
    geoMercator
  } from "d3-geo";
  import { interpolateHcl } from "d3-interpolate";

  import { debounce, scaleCanvas } from "./../utils.js";

  import stateShapes from "./../data/states.json";

  export let location = [];

  let width = 500;
  $: height = width * 0.7;
  let states = [];
  let projection = () => {};
  let pathGenerator = () => {};

  const sphere = { type: "Sphere" };

  const updateProjection = () => {
    projection = geoAlbersUsa().fitSize([width, height], sphere);
    // .center([-98.97699056370851,39.467312503662164])
    // .translate([-1, 50])
    projection.scale(projection.scale() * 1.2);
    pathGenerator = geoPath(projection);
    states = stateShapes.features.map(d => pathGenerator(d));
  };
  $: width, updateProjection();
</script>

<div class="c" bind:clientWidth="{width}">
  <div class="wrapper">
    <svg {width} {height}>
      <defs>
        <pattern
          id="texture"
          patternUnits="userSpaceOnUse"
          width="100%"
          height="100%">
          <image
            xlink:href="assets/map-texture.png"
            x="-50%"
            y="0"
            width="200%"
            height="200%"></image>
        </pattern>
      </defs>
      {#each states as d}
        <path class="state" {d}></path>
      {/each}
    </svg>
  </div>
  <div
    class="you"
    style="{`transform: translate(${(projection(location) || [])[0]}px, ${(projection(location) || [])[1]}px)`}"></div>
</div>

<style>
  .c {
    position: relative;
    width: 100%;
  }
  .wrapper {
    position: relative;
  }
  .wrapper:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #a8b0c4;
    z-index: 2;
    mix-blend-mode: color;
  }
  .state {
    fill: var(--gray);
    fill: url(#texture);
    stroke: #fff;
    stroke-width: 1;
  }
  .you {
    background: var(--c2);
    position: absolute;
    top: -6px;
    left: -6px;
    width: 12px;
    height: 12px;
    border: 2px solid white;
    border-radius: 100%;
    transition: all 0.3s ease-out;
    z-index: 100;
  }
  .you:before {
    content: "";
    position: absolute;
    top: -6px;
    right: -6px;
    bottom: -6px;
    left: -6px;
    border: 8px solid rgba(255, 255, 255, 0.2);
    border-radius: 100%;
  }
</style>
